import Spinner from './Spinner';
import CloudSpinner from './Cloud';

export {
  Spinner,
  CloudSpinner,
};
